import { contactData } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-send-plane-line"></i>
              投稿通道
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {contactData.title}
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              {contactData.subtitle}
            </p>
          </div>

          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center mb-8 max-w-2xl mx-auto">
              {contactData.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {contactData.channels.map((channel) => (
                <div
                  key={channel.label}
                  className="flex flex-col items-center text-center p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center mb-3">
                    <i className={`${channel.icon} text-xl`}></i>
                  </div>
                  <div className="text-xs text-foreground-500 mb-1">{channel.label}</div>
                  <div className="text-sm font-medium text-foreground-900 break-all">{channel.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}